/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateArticleHarmfulFactorSuppExamDictDto
 */
export interface CreateUpdateArticleHarmfulFactorSuppExamDictDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleHarmfulFactorSuppExamDictDto
     */
    articleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleHarmfulFactorSuppExamDictDto
     */
    harmfulFactorId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleHarmfulFactorSuppExamDictDto
     */
    supportingExaminationDictId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateArticleHarmfulFactorSuppExamDictDto interface.
 */
export function instanceOfCreateUpdateArticleHarmfulFactorSuppExamDictDto(value: object): value is CreateUpdateArticleHarmfulFactorSuppExamDictDto {
    return true;
}

export function CreateUpdateArticleHarmfulFactorSuppExamDictDtoFromJSON(json: any): CreateUpdateArticleHarmfulFactorSuppExamDictDto {
    return CreateUpdateArticleHarmfulFactorSuppExamDictDtoFromJSONTyped(json, false);
}

export function CreateUpdateArticleHarmfulFactorSuppExamDictDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateArticleHarmfulFactorSuppExamDictDto {
    if (json == null) {
        return json;
    }
    return {
        
        'articleId': json['articleId'] == null ? undefined : json['articleId'],
        'harmfulFactorId': json['harmfulFactorId'] == null ? undefined : json['harmfulFactorId'],
        'supportingExaminationDictId': json['supportingExaminationDictId'] == null ? undefined : json['supportingExaminationDictId'],
    };
}

export function CreateUpdateArticleHarmfulFactorSuppExamDictDtoToJSON(value?: CreateUpdateArticleHarmfulFactorSuppExamDictDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'articleId': value['articleId'],
        'harmfulFactorId': value['harmfulFactorId'],
        'supportingExaminationDictId': value['supportingExaminationDictId'],
    };
}

